import CreateQuestionModal from './CreateQuestionModal'

export default CreateQuestionModal;